import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import NewsTelop from "../components/NewsTelop";
import SkillSheetCreateStepper from "../components/skill_sheet_basic/pages/create/SkillSheetCreateStepper";
import UserContractRequestPage from "../components/user_contract_request/pages/UserContractRequestPage";
import ProjectRequestEdit from "../components/user_contract_request/pages/ProjectRequestEdit";
import UserJobRequestPage from "../components/user_job_request/pages/UserJobRequestPage";
import JobRequestEdit from "../components/user_job_request/pages/JobRequestEdit";
import AppRouter from "../AppRouter";
import "react-toastify/dist/ReactToastify.css";
import ToastProvider from "../components/shared/ToastProvider";
import CompanyUsers from "../components/company/users/CompanyUsers";
import UnreadProvider from "../components/shared/unread/UnreadProvider";

document.addEventListener("DOMContentLoaded", async () => {
  // ======== NewsTelop ========
  const reactNewsTelopContainers =
    document.querySelectorAll(".react-news-telop");
  reactNewsTelopContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const props = {
        newsContent: dataset.newsContent,
      };
      const reactNewsTelopRoot = createRoot(container);
      reactNewsTelopRoot.render(
        <React.StrictMode>
          <NewsTelop {...props} />
        </React.StrictMode>,
      );
    }
  });

  // ======== SkillSheetEditStepper (編集用) ========
  const skillSheetEditStepperContainers = document.querySelectorAll(
    ".react-skill-sheet-edit-stepper",
  );
  skillSheetEditStepperContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const skillSheetTemplate = dataset.skillSheetTemplate
        ? JSON.parse(dataset.skillSheetTemplate)
        : {};

      const props = {
        skillSheetTemplate,
        role: dataset.role,
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
      };

      const skillSheetEditStepperRoot = createRoot(container);
      skillSheetEditStepperRoot.render(
        <React.StrictMode>
          <SkillSheetEditStepper {...props} />
        </React.StrictMode>,
      );
    }
  });

  // ======== SkillSheetCreateStepper (新規登録用) ========
  const skillSheetCreateStepperContainers = document.querySelectorAll(
    ".react-skill-sheet-create-stepper",
  );
  skillSheetCreateStepperContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const skillSheetTemplate = dataset.skillSheetTemplate
        ? JSON.parse(dataset.skillSheetTemplate)
        : {};

      const props = {
        skillSheetTemplate,
        role: dataset.role,
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
      };

      const skillSheetCreateStepperRoot = createRoot(container);
      skillSheetCreateStepperRoot.render(
        <React.StrictMode>
          <SkillSheetCreateStepper {...props} />
        </React.StrictMode>,
      );
    }
  });

  // ======== UserContractRequestPage (プロジェクト希望条件閲覧)  ========
  const userContractRequestContainers = document.querySelectorAll(
    ".react-user-contract-request",
  );
  userContractRequestContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const userContractRequestInfo = dataset.userContractRequestInfo
        ? JSON.parse(dataset.userContractRequestInfo)
        : {};
      const userContractRequest = dataset.userContractRequest
        ? JSON.parse(dataset.userContractRequest)
        : {};
      const flashMessage = dataset.flashMessage
        ? JSON.parse(dataset.flashMessage)
        : null;
      const jobRecruitingFlag = dataset.jobRecruitingFlag
        ? JSON.parse(dataset.jobRecruitingFlag)
        : false;

      const props = {
        userContractRequestInfo,
        userContractRequest,
        flashMessage,
        jobRecruitingFlag,
      };

      const userContractRequestRoot = createRoot(container);
      userContractRequestRoot.render(
        <ToastProvider>
          <React.StrictMode>
            <UserContractRequestPage {...props} />
          </React.StrictMode>
        </ToastProvider>,
      );
    }
  });

  // ======== ProjectRequestEdit(プロジェクト希望条件編集)  ========
  const projectRequestEditContainers = document.querySelectorAll(
    ".react-user-contract-request-edit",
  );
  projectRequestEditContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const userContractRequest = dataset.userContractRequest
        ? JSON.parse(dataset.userContractRequest)
        : {};
      const flashMessage = dataset.flashMessage
        ? JSON.parse(dataset.flashMessage)
        : null;
      const props = {
        userContractRequest,
        flashMessage,
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
      };

      const root = createRoot(container);
      root.render(
        <React.StrictMode>
          <ProjectRequestEdit {...props} />
        </React.StrictMode>,
      );
    }
  });

  // ======== UserJobRequestPage (求人希望条件閲覧)  ========
  const userJobRequestContainers = document.querySelectorAll(
    ".react-user-job-request",
  );
  userJobRequestContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const userJobRequestInfo = dataset.userJobRequestInfo
        ? JSON.parse(dataset.userJobRequestInfo)
        : {};
      const userJobRequest = dataset.userJobRequest
        ? JSON.parse(dataset.userJobRequest)
        : {};
      const flashMessage = dataset.flashMessage
        ? JSON.parse(dataset.flashMessage)
        : null;
      const prefectures = dataset.prefectures
        ? JSON.parse(dataset.prefectures)
        : [];
      const contractRecruitingFlag = dataset.contractRecruitingFlag
        ? JSON.parse(dataset.contractRecruitingFlag)
        : false;

      const props = {
        userJobRequestInfo,
        userJobRequest,
        flashMessage,
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
        prefectures,
        contractRecruitingFlag,
      };

      const userJobRequestRoot = createRoot(container);
      userJobRequestRoot.render(
        <ToastProvider>
          <React.StrictMode>
            <UserJobRequestPage {...props} />
          </React.StrictMode>
        </ToastProvider>,
      );
    }
  });

  // ======== ProjectRequestEdit(プロジェクト希望条件編集)  ========
  const jobRequestEditContainers = document.querySelectorAll(
    ".react-user-job-request-edit",
  );
  jobRequestEditContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const userJobRequest = dataset.userJobRequest
        ? JSON.parse(dataset.userJobRequest)
        : {};
      const flashMessage = dataset.flashMessage
        ? JSON.parse(dataset.flashMessage)
        : null;

      const props = {
        userJobRequest,
        flashMessage,
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
      };

      const root = createRoot(container);
      root.render(
        <React.StrictMode>
          <JobRequestEdit {...props} />
        </React.StrictMode>,
      );
    }
  });

  // ======== companu_users(担当者) ========
  const container = document.getElementById("company-users-root");
  if (container) {
    const root = createRoot(container);
    root.render(
      <BrowserRouter>
        <CompanyUsers />
      </BrowserRouter>,
    );
  }

  // ======== AppRouter（ルーティング全体） ========
  const appRouterContainers = document.querySelectorAll(".react-app-router");
  appRouterContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const flashMessage = dataset.flashMessage
        ? JSON.parse(dataset.flashMessage)
        : null;
      const currentUser = dataset.currentUser
        ? JSON.parse(dataset.currentUser)
        : null;
      const currentCompanyUser = dataset.currentCompanyUser
        ? JSON.parse(dataset.currentCompanyUser)
        : null;
      const userJobRequestExists =
        dataset.userJobRequestExists === undefined
          ? undefined
          : dataset.userJobRequestExists === "true";

      const props = {
        flashMessage,
        currentUser,
        currentCompanyUser,
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
        targetUserId: dataset.targetUserId,
        targetUserType: dataset.targetUserType,
        workHistory: dataset.workHistory
          ? JSON.parse(dataset.workHistory)
          : null,
        userJobRequestExists,
        withdrawalAuthType: dataset.withdrawalAuthType || "password",
        withdrawalProvider: dataset.withdrawalProvider || null,
      };

      const shouldMountUnreadProvider = !!currentUser;

      const appRoot = createRoot(container);
      appRoot.render(
        <ToastProvider>
          <React.StrictMode>
            {shouldMountUnreadProvider ? (
              <UnreadProvider initialUnread={null}>
                <AppRouter {...props} />
              </UnreadProvider>
            ) : (
              <AppRouter {...props} />
            )}
          </React.StrictMode>
        </ToastProvider>,
      );
    }
  });

  // ======== CompanyMypage ========
  const mypageRootElement = document.getElementById("mypage-root");
  if (mypageRootElement) {
    const dataset = mypageRootElement.dataset;
    const flashMessage = dataset.flashMessage
      ? JSON.parse(dataset.flashMessage)
      : null;
    const currentUser = dataset.currentUser
      ? JSON.parse(dataset.currentUser)
      : null;

    const props = {
      flashMessage,
      currentUser,
      csrfToken: dataset.csrfToken,
      currentCompanyUser: dataset.currentCompanyUser
        ? JSON.parse(dataset.currentCompanyUser)
        : null,
      userJobRequestExists:
        dataset.userJobRequestExists === undefined
          ? undefined
          : dataset.userJobRequestExists === "true",
      withdrawalAuthType: dataset.withdrawalAuthType || "password",
      withdrawalProvider: dataset.withdrawalProvider || null,
    };

    const root = createRoot(mypageRootElement);
    root.render(
      <ToastProvider>
        <React.StrictMode>
          <AppRouter {...props} />
        </React.StrictMode>
      </ToastProvider>,
    );
  }
});
